/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal, Switch, Text, TextInput } from "@mantine/core";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import { useState } from "react";
import {
  CreateTemplateSectionInput,
  CreateTemplateSectionMutation,
  CreateTemplateSectionMutationVariables
} from "../../../API";
import { createTemplateSection } from "../../../graphql/mutations";
import { databaseMigrationAdapter } from "@/services/DatabaseMigrationAdapter";
const client = generateClient();

type addNewSectionTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  fetchTemplate: (templateId: string) => void;
};

const AddSectionTemplateModal = (props: addNewSectionTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sectionSimple, setSectionSimple] = useState<boolean>(false);
  const handleAddSection = async () => {
    setIsLoading(true);
    try {
      // Use your GraphQL client to make a mutation call
      const createSectionInput: CreateTemplateSectionInput = {
        name: sectionName,
        isSimple: sectionSimple,
        tID: template.id
      };
      const createSectionVars: CreateTemplateSectionMutationVariables = {
        input: createSectionInput
      };
      try {
        console.log('[REACT-HOOK] Calling Amplify createTemplateSection GraphQL mutation');
        const createSectionResult = await client.graphql<
          GraphQLQuery<CreateTemplateSectionMutation>
        >({ query: createTemplateSection, variables: createSectionVars });
        
        console.log('[REACT-HOOK] Amplify section creation successful, calling database migration service');
        // Call database migration service for logging and dual-write
        await databaseMigrationAdapter.handleSectionOperation('CREATE', createSectionInput, createSectionResult as unknown as Record<string, unknown>);
        
        console.log(createSectionResult);
      } catch (err) {
        console.log(err);
      }
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error creating section:", err);
      setIsLoading(false);
    }
  };
  const closeAndResetModal = () => {
    setModalOpened(false);
    setErrorMsg("");
    setSectionName("");
    setSectionSimple(false);
  };
  return (
    <Modal
      opened={modalOpened}
      onClose={closeAndResetModal}
      title="Add section"
    >
      <TextInput
        label="Name"
        placeholder="Enter template section"
        value={sectionName}
        onChange={(event) => setSectionName(event.target.value)}
        required
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Switch
        checked={sectionSimple}
        fw={600}
        my={10}
        labelPosition="left"
        label="Simple section"
        onChange={(e) => setSectionSimple(e.currentTarget.checked)}
      />

      <Group mt="md">
        <Group mt="md">
          <Button loading={isLoading} onClick={handleAddSection}>
            Save
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default AddSectionTemplateModal;
